import { render, staticRenderFns } from "./SeleccionarPerfilSga.vue?vue&type=template&id=61f47ade&scoped=true"
import script from "./SeleccionarPerfilSga.vue?vue&type=script&setup=true&lang=js"
export * from "./SeleccionarPerfilSga.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SeleccionarPerfilSga.vue?vue&type=style&index=0&id=61f47ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61f47ade",
  null
  
)

export default component.exports